import { getActiveToken, useUserContext } from "utils";

/** True once there is a signed-in user with an active token — the gate every authenticated query and mutation shares. */
export const useIsAuthenticated = (): boolean => {
  const { user } = useUserContext();
  const token = getActiveToken();
  return !!user && !!token;
};
